(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["athlete-popup-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('athlete-popup-card')) {
    class AthletePopupCard extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-athlete-popup-trigger]');
        this.dialog = this.querySelector('[data-athlete-popup-dialog]');
        this.closeButton = this.querySelector('[data-athlete-popup-close]');

        if (!this.trigger || !this.dialog || !this.closeButton) return;

        this.trigger.addEventListener('click', () => this.dialog.showModal());
        this.closeButton.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    }

    customElements.define('athlete-popup-card', AthletePopupCard);
  }
  } catch(e) { console.error(e); }
})();

})();
